export class EscalatedRisk {
  id: number;
  description: string;
  reviewDetails: string;
  reviewResult: number;
  createdBy: number;
  toBeReviewedBy: number;
  relatedRiskId: number;
  createdDate: Date;
  reviewedDate: Date;

}
